import { CashTransaction } from '@/@types/cash-management';
import { PrintLayout } from '@/@types/print';
import { PRINT_LAYOUT_1 } from '@/modules/utils/print-layouts';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { CashSessionManualMovementPosPrint } from './CashSessionManualMovementPosPrint';

type ManualMovementPrintRequest = {
  copies: number;
  selectedLayout: PrintLayout;
  transaction: CashTransaction;
};

type UseCashSessionManualMovementPrintResult = {
  isPrintingManualMovement: boolean;
  printManualMovementNode: ReactNode;
  printManualMovement: (
    // eslint-disable-next-line no-unused-vars
    transaction: CashTransaction,
    // eslint-disable-next-line no-unused-vars
    copies?: number,
    // eslint-disable-next-line no-unused-vars
    selectedLayout?: PrintLayout
  ) => void;
};

export function useCashSessionManualMovementPrint(): UseCashSessionManualMovementPrintResult {
  const [printRequest, setPrintRequest] =
    useState<ManualMovementPrintRequest>();
  const printRef = useRef<HTMLDivElement | null>(null);

  const handleAfterPrint = () => {
    setPrintRequest((currentRequest) => {
      if (!currentRequest) return undefined;

      if (currentRequest.copies <= 1) return undefined;

      return { ...currentRequest, copies: currentRequest.copies - 1 };
    });
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: handleAfterPrint,
  });

  useEffect(() => {
    if (!printRequest) return;

    handlePrint();
  }, [handlePrint, printRequest]);

  const printManualMovement = (
    transaction: CashTransaction,
    copies = 1,
    selectedLayout = PRINT_LAYOUT_1
  ) => {
    if (printRequest) return;

    setPrintRequest({
      copies: Math.max(1, copies),
      selectedLayout,
      transaction,
    });
  };

  return {
    isPrintingManualMovement: !!printRequest,
    printManualMovement,
    printManualMovementNode: (
      <div style={{ display: 'none' }}>
        <CashSessionManualMovementPosPrint
          transaction={printRequest?.transaction}
          containerRef={printRef}
          selectedLayout={printRequest?.selectedLayout}
        />
      </div>
    ),
  };
}
